/*    
<summary>
  This functional component "AddProductManagementForm" provides form to add new user or update existing user.
  Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
<returns>Returns JSX</returns>
*/

import {
  Field,
  Form,
  Formik,
  useFormikContext
} from "formik";
import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import {
  integerNumJpRegex,
  integerRegex
} from "../../../../constants/constants";
import { useStore } from "../../../../contexts/store-provider";
import FormikFormInput from "../../../../shared-components/FormikFormHandlers/FormikFormInput";
import FormikFormInputForRegexCheck from "../../../../shared-components/FormikFormHandlers/FormikFormInputForRegexCheck";
import Label from "../../../../shared-components/label/label";
import { formatMessage } from "../../../../translations/format-message";

import { observer } from "mobx-react";
import toast from "react-hot-toast";
import {
  getDaysArrayForMonth,
  getMonthsArray,
  getYearsArray,
} from "../../../../helpers/date-time-helper";
import { toHalfWidth } from "../../../../helpers/validate-helper";
import FormikFormInputAddress from "../../../../shared-components/FormikFormHandlers/FormikFormInputAddress";
import FormikFormInputMobileNumber from "../../../../shared-components/FormikFormHandlers/FormikFormInputMobileNumber";
import FormikFormSelect from "../../../../shared-components/FormikFormHandlers/FormikFormSelect";
import {
  customerRegistrationSchema,
  validateCustomerAuthCodeSchema,
  validateCustomerRegisterNowSchema,
} from "../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import FormLoader from "../../../../shared-components/FormLoader/FormLoader";
import "../../../auth/login.css";
import FormikFormNumberInput from "../../../../shared-components/FormikFormHandlers/FormikFormNumberInput";
import ConfirmPopupHOC from "../../../../shared-components/popup/confirm/confirm-popup-hoc";
import ConfirmPopup from "../../../../shared-components/popup/confirm/confirm-popup";
import RegisterCustomerAlreadyExistsPopup from "../../../../shared-components/popup/confirm/register-customer-already-exists";
import ResetPasswordWindowPopupHOC from "../../../../shared-components/popup/change-password/reset-password-window-popup-hoc";
import FormikFormPasswordInput from "../../../../shared-components/FormikFormHandlers/FormikFormPasswordInput";
import { FormObserver } from "../../../../shared-components/address/form-observer";

interface IProps {
  id: number;
  submitHandler: (data: any) => void;
  getCustomerLoading: boolean;
  initialValues: any;
  modalClosed:() => void;
  changeForm: (formNo: any) => void;
  confirmPopupToggleHandler: () => void;
    resetPasswordToggleHandler: () => void;
  showResetPasswordPopup: boolean;
  showConfirmPopup: boolean;
}

const SignUpCustomerForm = (props: IProps) => {

  const { storeManagementStore, customerManagementStore, authStore, bookingManagementStore } = useStore();
  const { GetPrefectureUsingPostalCode, prefectureByZipCode } =
    storeManagementStore;
  const {
    addUpdateCustomerState,
    isCustomerValidated,
    resetIsCustomerValidated,
    validateCustomerState,
    ValidateCustomerService,
    resetValidateCustomerState,
    customerRegistrationDetail,
    resetCustomerDetail,
    customerState
  } = customerManagementStore;
    const {
    AuthenticateCustomerAuthCodeService,
    isCustomerAuthCodeValidated,
    authenticateCustomerAuthCodeState,
    resetAuthenticateCustomerAuthCode,
    resetAuthenticateCustomerAuthCodeError,
    setIsCustomerAuthCodeValidatedFalse
  } = authStore;
  const { resetAddUpdateCustomer } = bookingManagementStore;
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [postalCode, setPostalCode] = useState<string>("");
  const [address12, setAddress12] = useState<string>("");
  const [attemptsRemaining, setAttemptRemaining] = useState<number>(3);
  const resetFormRef = useRef<(() => void) | null>(null);

  const [lastNameKana, setLastNameKana] = useState<string>("");
  const [firstNameKana, setFirstNameKana] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone1, setPhone1] = useState<string>("");
  const [isEmailOverwrite, setIsEmailOverwrite] = useState<boolean>(false);

  const initialValidateFormValues = {
    FirstNameKana: "",
    LastNameKana: "",
    Phone1: "",
    Email: "",
  };

  
  const initialOTPFormValues = {
    Email: email,
    AuthCode: "",
    AuthType: 0,
  };

  // const initialCustomerRegistrationFormValues = {
  //   ...props.initialValues,
  //   FirstNameKana: isCustomerValidated ? firstNameKana : "",
  //   LastNameKana: isCustomerValidated ? lastNameKana : "",
  //   Phone1: isCustomerValidated ? phone1 : "",
  //   Email: isCustomerValidated ? email : "",
  //   ConfirmPassword: "",
  // };

  useEffect(() => {
    return () => {
      setFirstNameKana("");
      setLastNameKana("");
      setEmail("");
      setPhone1("");
      resetIsCustomerValidated();
      resetValidateCustomerState();
      setIsEmailOverwrite(false);
      resetCustomerDetail();
      setIsCustomerAuthCodeValidatedFalse();
    };
  }, []);

  useEffect(() => {
    if (postalCode && postalCode?.length == 7) {
      GetPrefectureUsingPostalCode(postalCode);
    }
  }, [postalCode]);

  useEffect(() => {
    if (validateCustomerState.success) {
      if(props.showConfirmPopup)
        props.confirmPopupToggleHandler();
      resetValidateCustomerState();
    }
  }, [validateCustomerState.success]);

  useEffect(() => {
    if (validateCustomerState.error) {
      if (
      validateCustomerState.error == "IsThereADifferentEmailIdForThisAccount"
    ) {
      props.confirmPopupToggleHandler();
    }
          else if(validateCustomerState.error == "LizeraCustomerAlreadyExist" || validateCustomerState.error == "LizeraRegisteredCustomerAlreadyExists"){
        props.resetPasswordToggleHandler();
      } 
     else {
      toast.error(formatMessage(validateCustomerState.error));
    }
      resetValidateCustomerState();
    }
  }, [validateCustomerState.error]);

    useEffect(() => {
    if (authenticateCustomerAuthCodeState.success) {
      toast.success(formatMessage("authentication_success"));
    }
  }, [authenticateCustomerAuthCodeState.success]);

  useEffect(() => {
    if (authenticateCustomerAuthCodeState.error) {
      toast.error(formatMessage(authenticateCustomerAuthCodeState.error));
      resetAuthenticateCustomerAuthCodeError();
      setAttemptRemaining(attemptsRemaining-1);
    }
  }, [authenticateCustomerAuthCodeState.error]);

    useEffect(()=>{
    if(attemptsRemaining == 0){
      toast.error(formatMessage('maximum_attempts_limit_reached'));
      resetAddUpdateCustomer();
      resetIsCustomerValidated();
      resetAuthenticateCustomerAuthCode();
      setIsCustomerAuthCodeValidatedFalse();
      setAttemptRemaining(3);
    }
  },[attemptsRemaining]);


  useEffect(() => {
    if (addUpdateCustomerState.success && resetFormRef.current) {
      resetFormRef.current(); // Reset the form
      setIsEmailOverwrite(false);
    }
  }, [addUpdateCustomerState.success]);

  const validateSubmitHandler = (values: any) => {
    setLastNameKana(values.LastNameKana);
    setFirstNameKana(values.FirstNameKana);
    setEmail(values.Email);
    setPhone1(toHalfWidth(values.Phone1));
    ValidateCustomerService(values);
  };

    const validateAuthenticateSubmitHandler = (values: any) => {
    AuthenticateCustomerAuthCodeService({
      Email: values.Email,
      AuthCode: values.AuthCode,
      AuthType: values.AuthType,
    });
  };

  return (
    <>
      <>
        {(validateCustomerState.inProgress ||
          customerState.inProgress ||
          addUpdateCustomerState.inProgress) && (
          <FormLoader
            loading={
              validateCustomerState.inProgress ||
              customerState.inProgress ||
              addUpdateCustomerState.inProgress
            }
          />
        )}

        
        {props.showResetPasswordPopup && (
          <RegisterCustomerAlreadyExistsPopup
            modalClosed={() => {
              props.modalClosed();
              props.resetPasswordToggleHandler();
            }}
            title="customer_registration"
            message={validateCustomerState.error == "LizeraCustomerAlreadyExist" ? "lizera_customer_already_exists" : "lizera_registered_customer_already_exists"}
            isLoading={false}
          />
        )}

        {props.showConfirmPopup && (
          <ConfirmPopup
            isLoading={false}
            title="confirmation_popup_title"
            message="IsThereADifferentEmailIdForThisAccountInfo"
            modalSubmit={()=>{
              ValidateCustomerService({
                FirstNameKana: firstNameKana,
                LastNameKana: lastNameKana,
                Phone1: phone1,
                Email: email,
                IsOverwriteEmail: true
              });
              setIsEmailOverwrite(true);
            }}
            modalClosed={props.confirmPopupToggleHandler}
          />
        )}
        {!isCustomerValidated && (
          <Formik
            initialValues={initialValidateFormValues}
            enableReinitialize={true}
            validationSchema={validateCustomerRegisterNowSchema}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={(values) => {
              const updatedValues = {
                LastNameKana: values.LastNameKana?.trim(),
                FirstNameKana: values.FirstNameKana?.trim(),
                Email: values.Email?.toLowerCase(),
                Phone1: toHalfWidth(values.Phone1),
              };
              validateSubmitHandler(updatedValues);
            }}
          >
            {({ values }) => {
              return (
                <Form className="modal-body p-4">
                  {props.getCustomerLoading ? (
                    <FormLoader loading={props.getCustomerLoading} />
                  ) : null}
                  <div className="row card-body">
                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="last_name_kana"
                      />
                      <Field
                        name="LastNameKana"
                        type="text"
                        className="form-control"
                        placeholder="last_name_kana"
                        // regex={stringJpRegex}
                        as={FormikFormInput}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="first_name_kana"
                      />
                      <Field
                        name="FirstNameKana"
                        type="text"
                        className="form-control"
                        placeholder="first_name_kana"
                        // regex={stringJpRegex}
                        as={FormikFormInput}
                      />
                    </div>
                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="email"
                      />
                      <Field
                        className="form-control"
                        name="Email"
                        type="email"
                        autoComplete="new-email"
                        placeholder="enter_email"
                        validcharacter={["@", "#", "$", "-", "_", "."]}
                        as={FormikFormInput}
                      />
                    </div>

                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="phone1"
                      />
                      <Field
                        name="Phone1"
                        type="text"
                        className="form-control"
                        placeholder="enter_mobile_number"
                        regex={integerRegex}
                        as={FormikFormInputMobileNumber}
                      />
                    </div>
                  </div>
                  <div className="align-items-center mt-3 justify-content-center d-flex gap-3">
                    <Button type="submit" className="btn btn-primary">
                      {formatMessage("validate")}
                    </Button>
                    {/* <Button
                      variant="btn btn-secondary"
                      onClick={() => props.changeForm(2)}
                    >
                      <FormattedMessage id="continue_without_login" />
                    </Button> */}
                    {/* <Button
                      variant="outline-primary"
                      type="button"
                      onClick={() => props.changeForm(1)}
                    >
                      <FormattedMessage id="login_book" />
                    </Button> */}
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}

                {isCustomerValidated == true &&
        addUpdateCustomerState.success == false &&
        authenticateCustomerAuthCodeState.success == false && (
          <Formik
            initialValues={initialOTPFormValues}
            enableReinitialize={true}
            validationSchema={validateCustomerAuthCodeSchema}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={(values) => {
              validateAuthenticateSubmitHandler(values);
            }}
          >
            {({ values }) => {
              return (
                <Form className="modal-body p-4">
                  {props.getCustomerLoading ? (
                    <FormLoader loading={props.getCustomerLoading} />
                  ) : null}
                  <div className="row card-body">
                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="email"
                      />
                      <Field
                        className="form-control"
                        name="Email"
                        type="email"
                        disabled={email !== "" ? true : false}
                        autoComplete="new-email"
                        placeholder="enter_email"
                        validcharacter={["@", "#", "$", "-", "_", "."]}
                        as={FormikFormInput}
                      />
                    </div>

                    <div className="col-12 form-group">
                      <Label
                        className="label-style"
                        required={true}
                        label="otp"
                      />
                      <Field
                        name="AuthCode"
                        type="number"
                        className="form-control"
                        placeholder="enter_4_digit_auth_code"
                        regex={integerRegex}
                        as={FormikFormNumberInput}
                      />
                    </div>
                  </div>
                  <p>
                    {attemptsRemaining} <FormattedMessage id="remaining_attempts" />
                  </p>
                  <div className="align-items-center mt-3 justify-content-center d-flex gap-3">
                    <Button type="submit" className="btn btn-primary">
                      <FormattedMessage id="validate" />
                    </Button>
                    {/* <Button
                      variant="btn btn-secondary"
                      onClick={() => props.changeForm(2)}
                    >
                      <FormattedMessage id="continue_without_login" />
                    </Button>
                    <Button
                      variant="outline-primary"
                      type="button"
                      onClick={() => props.changeForm(1)}
                    >
                      <FormattedMessage id="login_book" />
                    </Button> */}
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
        
      </>
      {isCustomerAuthCodeValidated && (
        <Formik
          initialValues={{
            ...customerRegistrationDetail,
            FirstNameKana: isCustomerValidated ? firstNameKana : "",
            LastNameKana: isCustomerValidated ? lastNameKana : "",
            Phone1: isCustomerValidated ? phone1 : "",
            Email: isCustomerValidated ? email : "",
            ConfirmPassword: "",
            Password: "",
          }}
          enableReinitialize={true}
          validationSchema={customerRegistrationSchema}
          validateOnBlur={true}
          validateOnChange={true}
          onSubmit={(values, { resetForm }) => {
            const updatedValues = {
              ...values,
              Dob:
                values.DobDate &&
                values.DobMonth &&
                values.DobYear &&
                values.DobDate > 0 &&
                values.DobMonth > 0 &&
                values.DobYear > 0
                  ? `${values.DobYear}-${values.DobMonth}-${values.DobDate}`
                  : null,
              Email: values.Email?.toLowerCase(),
              RegisteredBy: 2,
              CustomerType: 0,
              Status: 1,
              PostalCode: toHalfWidth(values.PostalCode),
              Phone1: toHalfWidth(values.Phone1),
              IsOverwriteEmail: isEmailOverwrite,
              Referer: values.Referer > 0 ? values.Referer : null
            };
            props.submitHandler(updatedValues);
            resetFormRef.current = resetForm; // Save for later call
          }}
        >
          {({ setFieldValue, values, errors }) => {
            return (
              <Form className="modal-body p-4">
                {props.getCustomerLoading ? (
                  <FormLoader loading={props.getCustomerLoading} />
                ) : null}
                <FormObserver
                  prefectureByZipCode={prefectureByZipCode}
                  initialPostalCode={props.initialValues.PostalCode}
                />
                {/* Account Details */}
                <h3>
                  <FormattedMessage id="account_details" />
                  <span className="ms-2">
                    <i className="bi bi-check-circle-fill 2x text-success"></i>
                  </span>
                </h3>
                <div className="row card-body">
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="last_name_kana"
                    />
                    <Field
                      name="LastNameKana"
                      type="text"
                      className="form-control"
                      placeholder="last_name_kana"
                      // regex={stringJpRegex}
                      as={FormikFormInput}
                      disabled={true}
                    />
                  </div>
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="first_name_kana"
                    />
                    <Field
                      name="FirstNameKana"
                      type="text"
                      className="form-control"
                      placeholder="first_name_kana"
                      // regex={stringJpRegex}
                      as={FormikFormInput}
                      disabled={true}
                    />
                  </div>
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="email"
                    />
                    <Field
                      className="form-control"
                      name="Email"
                      type="email"
                      autoComplete="new-email"
                      placeholder="enter_email"
                      validcharacter={["@", "#", "$", "-", "_", "."]}
                      as={FormikFormInput}
                      disabled={true}
                    />
                  </div>

                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="phone1"
                    />
                    <Field
                      name="Phone1"
                      type="text"
                      className="form-control"
                      placeholder="enter_mobile_number"
                      regex={integerRegex}
                      as={FormikFormInputMobileNumber}
                      disabled={true}
                    />
                  </div>
                </div>

                {/* Personal Details */}
                <h3><FormattedMessage id="personal_details" /></h3>
                {/* <Label className="label-style" required={true} label="name" /> */}
                <div className="row">
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={false}
                      label="last_name"
                    />
                    <Field
                      name="LastName"
                      type="text"
                      className="form-control"
                      placeholder="enter_last_name"
                      as={FormikFormInput}
                    />
                  </div>
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={false}
                      label="first_name"
                    />
                    <Field
                      name="FirstName"
                      type="text"
                      className="form-control"
                      placeholder="enter_first_name"
                      as={FormikFormInput}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="password"
                    />
                    <div className="position-relative">
                      <Field
                        className="form-control "
                        name="Password"
                        autoComplete="new-password"
                        placeholder="enter_new_password"
                        invalidcharacter={[" "]}
                        validcharacter={[
                          "~",
                          "`",
                          "!",
                          "@",
                          "#",
                          "$",
                          "%",
                          "^",
                          "&",
                          "*",
                          "(",
                          ")",
                          "_",
                          "-",
                          "+",
                          "=",
                          "{",
                          "[",
                          "}",
                          "]",
                          "|",
                          "\\",
                          ":",
                          ";",
                          "'",
                          '"',
                          "<",
                          ",",
                          ">",
                          ".",
                          "?",
                          "/",
                        ]}
                        as={FormikFormPasswordInput}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 form-group">
                    <Label
                      className="label-style"
                      required={true}
                      label="confirm_password"
                    />
                    <div className="form-group">
                      <Field
                        className="form-control"
                        name="ConfirmPassword"
                        placeholder="enter_confirm_password"
                        as={FormikFormPasswordInput}
                        invalidcharacter={[" "]}
                        validcharacter={[
                          "~",
                          "`",
                          "!",
                          "@",
                          "#",
                          "$",
                          "%",
                          "^",
                          "&",
                          "*",
                          "(",
                          ")",
                          "_",
                          "-",
                          "+",
                          "=",
                          "{",
                          "[",
                          "}",
                          "]",
                          "|",
                          "\\",
                          ":",
                          ";",
                          "'",
                          '"',
                          "<",
                          ",",
                          ">",
                          ".",
                          "?",
                          "/",
                        ]}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6 form-group ">
                    <Label
                      className="label-style"
                      required={false}
                      label="gender"
                    />
                    <br />
                    <Field
                      className="form-check-input"
                      name="Gender"
                      type="radio"
                      value="0"
                      id="male"
                    />
                    <label className="form-check-label me-3" htmlFor="male">
                      <FormattedMessage id="male" />
                    </label>
                    <Field
                      className="form-check-input"
                      name="Gender"
                      type="radio"
                      value="1"
                      id="female"
                    />
                    <label className="form-check-label me-3" htmlFor="female">
                      <FormattedMessage id="female" />
                    </label>
                    <Field
                      className="form-check-input"
                      name="Gender"
                      type="radio"
                      value="2"
                      id="not_set"
                    />
                    <label className="form-check-label me-3" htmlFor="not_set">
                      <FormattedMessage id="not_set" />
                    </label>
                  </div>

                  <div className="col-sm-6">
                    <Label
                      className="label-style"
                      required={false}
                      label="date_of_birth"
                    />
                    <div className="d-flex gap-2">
                      <div className="form-group">
                        <Field
                          className="form-control"
                          name="DobYear"
                          options={getYearsArray()}
                          as={FormikFormSelect}
                          showErrorField={false}
                        />
                      </div>
                      <div className="form-group">
                        <Field
                          className="form-control"
                          name="DobMonth"
                          options={getMonthsArray()}
                          as={FormikFormSelect}
                          showErrorField={false}
                        />
                      </div>
                      <div className="form-group">
                        <Field
                          className="form-control"
                          name="DobDate"
                          options={getDaysArrayForMonth(
                            values.DobYear,
                            values.DobMonth
                          )}
                          as={FormikFormSelect}
                          showErrorField={false}
                        />
                      </div>
                    </div>
                    {errors.DobYear && (
                      <div className="text-danger errorMessage">
                        {typeof errors.DobYear === "string" ? (
                          formatMessage(errors.DobYear)
                        ) : (
                          <></>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                {/* Address */}
                <h3><FormattedMessage id="address" /></h3>
                <div className="form-group row align-items-center">
                  <div className="postal-code-width col-4">
                    <Label
                      className="label-style"
                      required={false}
                      label="postal_code"
                    />
                    <Field
                      className="form-control"
                      name="PostalCode"
                      type="text"
                      placeholder="enter_post_code"
                      regex={integerNumJpRegex}
                      setState={setPostalCode}
                      as={FormikFormInputForRegexCheck}
                    />
                  </div>
                  <div className="next-postal-code-width col-8">
                    <Label
                      className="label-style"
                      required={false}
                      label="address"
                    />
                    <Field
                      className="form-control"
                      name="Address"
                      type="text"
                      placeholder="enter_address"
                      prefectureName={values.PrefectureName}
                      validcharacter={["@", "#", "$", "-", "_", ".", "/"]}
                      as={FormikFormInputAddress}
                    />
                  </div>
                </div>

                {/* Other Details */}
                <h3><FormattedMessage id="other_details" /></h3>

                <div className="form-group">
                  <Field name="DmDshs">
                    {({ field, form }: { field: any; form: any }) => (
                      <div className="form-group row">
                        <div className="col-12">
                          <Label
                            className="label-style"
                            required={false}
                            label="dm"
                          />
                          <br />
                          <input
                            className="form-check-input"
                            type="radio"
                            id="yes"
                            checked={field.value === "true"}
                            onChange={() => form.setFieldValue("DmDshs", "true")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="yes"
                          >
                            <FormattedMessage id="yes" />
                          </label>

                          <input
                            className="form-check-input"
                            type="radio"
                            id="no"
                            checked={field.value === "false"}
                            onChange={() => form.setFieldValue("DmDshs", "false")}
                          />
                          <label className="form-check-label" htmlFor="no">
                            <FormattedMessage id="no" />
                          </label>
                        </div>
                      </div>
                    )}
                  </Field>
                </div>
                <div className="align-items-center mt-3 justify-content-end d-flex gap-3">
                  <Button type="submit" className="btn btn-primary">
                    <FormattedMessage id="button_register" />
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};

export default ResetPasswordWindowPopupHOC(ConfirmPopupHOC(observer(SignUpCustomerForm)));
